<template>
  <div :class="alto_contenido()">
    <div class="container mt-4 mb-4">
      <!-- <atras-component></atras-component> -->


      <div class="d-flex justify-content-between">
        <div class="ml-3 mb-2">
          <h6 class="subtitulo mb-2 textoFijo">Comité de Ética y de Prevención de Conflictos de Interés</h6>
          <div class="lineaNegra"></div>
          <div class="mt-1 mb-2 lineaNegra2"></div>
        </div>
        <div>
          <boton-atras :nombre_ruta="'manuales-administrativos'"></boton-atras>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
        <tabla :documentos="sections" :urlServe="urlServe"
        />
        <!-- {{this.sections}} -->
        <div class="col-md-12">
          <div class="tarjeta-presentacion">
            <!-- <img src="assets/imagenes/hacienda_chiapas.png" alt=""> -->
            <h3>Buzón de Denuncias</h3>
            <p>Datos del contacto:</p>
            <ul>
              <li style="font-weight:bold;" >Juan Pablo Cal y Mayor Franco</li>
              <li>Jefe del Área de Recursos Humanos y Secretario Ejecutivo del CEPCI</li>
              <li>Correo Electrónico</li>
              <li>cepci.denuncias@{{urlSubdominio}}</li>
              <li><a :href="urlServe+'codigo-etica/SFCEPCI001-F.pdf'" target="_blank">Formato de Denuncia</a></li>
              <li><a :href="urlServe+'codigo-etica/SFCEPCI001-I.pdf'" target="_blank">Instructivo de Llenado</a></li>
            </ul>
            <!-- <ul>
              <li style="font-weight:bold;" >Mta. Claudia Cano Moguel</li>
              <li>Secretaria Ejecutiva del CEPCI y Jefa del Área de Recursos Humanos</li>
              <li>Correo Electrónico</li>
              <li>cepci.denuncias@{{urlSubdominio}}</li>
              <li><a :href="'http://presupuesto.' + urlSubdominio + '/SAF/formatos/73/84/347/R1/SHCEPCI001-F.pdf'" target="_blank">Formato de Denuncia</a></li>
              <li><a :href="'http://presupuesto.' + urlSubdominio + '/SAF/formatos/73/84/347/R1/SHCEPCI001-I.pdf'" target="_blank">Instructivo de Llenado</a></li>
            </ul> -->
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.tarjeta-presentacion {
  max-width: auto;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
  font-family: Arial, sans-serif;
  color: #333;
  /* border:1px solid #621132; */
}

.tarjeta-presentacion h3 {
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: #2c3e50;
  font-weight: 600;
  text-align: center;
}

.tarjeta-presentacion p {
  font-size: 1.2rem;
  color: #7f8c8d;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center;
}

.tarjeta-presentacion ul {
  list-style: none;
  padding: 0;
  text-align: center;
}

.tarjeta-presentacion ul li {
  font-size: 1rem;
  margin-bottom: 10px;
  line-height: 1;
}

.tarjeta-presentacion ul li a {
  color: #621132;
  text-decoration: none;
  font-weight: 500;
}

.tarjeta-presentacion ul li a:hover {
  color: #621132;
  text-decoration: none;
}

/* Opcional: Estilo especial para el correo electrónico */
.tarjeta-presentacion ul li:nth-child(4) {
  font-weight: bold;
  color: #34495e;
}
</style>
<script>
import mapFun from "@/common/map-fn-types.js";
import mixin from "@/mixins/mixin.js";
import atrasComponent from './../../reload.vue'
import botonAtras from './../../button-atras'
import comiteEticaPrevencionCI from '@/services/conocenos/integridadPublica.js'
const comiteEticaPrevencionCI_Service = new comiteEticaPrevencionCI();
import tabla from '../../../components/tableModelo7-ver2.vue'

export default{
data(){
        return{
          sections:[],
        }
    },
    async created (){
        this.getContenido();
    },
     mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        atrasComponent,
        botonAtras,
        tabla,
    },
    mixins: [mixin],
    methods:{
        alto_contenido(){ if(screen.width > 1280)  return 'pantalla_grande' },
        async getContenido(){
            try {
                const response = await comiteEticaPrevencionCI_Service.getComiteEticaPrevencionCI(mapFun.comiteEticaPrevencion);
                this.sections = response
            } catch (error) {
                console.log('error v', error.message);
            }
        },
    }
}
</script>
